import { GetContextMenuItemsParams } from 'ag-grid-enterprise'
import { Check } from 'lucide-react'
import { renderToString } from 'react-dom/server'

import { CustomMenuItem } from '@fortem-monorepo/react-ag'
import { Audit } from '@fortem-monorepo/web-sdk'

import { useUserContext } from '@/index'
import { useApproveElementMutation } from '@/react-query/mutations/audit'
import { useInternalUser } from '@/react-query/queries/account'

type Options = {
  approve: {
    label: string
    element_type: Audit.ElementType
  }
}

export const useAuditMenuItems = <TData extends Audit.WithApprovalInfo>(options: Options) => {
  const { approve } = options
  const { isDeveloper } = useUserContext()
  const { internalUser } = useInternalUser()
  const approveMutation = useApproveElementMutation()

  return {
    approve: (
      params: GetContextMenuItemsParams<TData>,
      id_col: keyof TData,
    ): CustomMenuItem<TData> | undefined => {
      const data = params.node?.data
      const status = data?.status
      // @ts-expect-error
      const element_id: string | number = data?.[id_col]!
      const statusIsNotApproved = status !== Audit.STATUSES.APPROVED
      const lastUpdatedByUser = internalUser?.user_id == data?.submitted_by
      const canApprove = statusIsNotApproved && (!lastUpdatedByUser || isDeveloper())

      if (!canApprove) return undefined

      return {
        name: approve.label,
        icon: renderToString(<Check size={16} />),
        cssClasses: ['hover:bg-green-100!', 'text-green-600!'],
        action: () => {
          return approveMutation.mutateAsync({
            element_id,
            element_type: approve.element_type,
          })
        },
      }
    },
  }
}
